<div id="overlay" class="page-overlay" (click)="handleCloseOverlay()">
   
    <div id="content" class="content-wrapper" (click)="$event.stopPropagation()">

        <div class="close-icon" (click)="handleCloseOverlay()" *ngIf="animationComplete">
            <app-svg-loader height="16px" url="assets/svg/plus-outline.svg"></app-svg-loader>
        </div>

        <div class="content" *ngIf="animationComplete">
            <ng-content></ng-content>
        </div>
    </div>
</div>
